<template>
  <ListContainer v-show="loadingCompleted" class="max-width" itemKey="no"
    :fetch="fetch"
    :filter="filter"
    :limit="limit"
    :emptyHint="emptyHint"
    :spinner="spinnerStyle"
    @initialized="patchReadTime"
    @reachBottom="showBottomHint = true"
  >
    <template v-slot:list-item="{ item }">
      <NotificationItem :notification="item" :defaultThumbnail="defaultThumbnail" />
    </template>
    <template v-slot:list-footer>
      <div v-if="showBottomHint" class="py-2 text-center bg-gray200 font-size-sm">{{ $t('notification.bottom-hint') }}</div>
    </template>
  </ListContainer>
</template>

<script>
import { mapState } from 'vuex';
import { map } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import NotificationItem from '@/components/notification/NotificationItem.vue';
import ListContainer from '@/components/ListContainer.vue';
import pageSettingGetter from '@/utils/pageSettingGetter';
import mbcService from '@/services/mbcService';

export default {
  components: {
    NotificationItem,
    ListContainer,
  },
  computed: {
    ...mapState(['accessToken']),
  },
  data() {
    return {
      // 讀取中spinner樣式
      spinnerStyle: '',
      // 列表資料篩選設定
      filter: {
        dayFilter: 90,
      },
      // 最愛空白頁設定
      emptyHint: {
        desc: '',
        img: '',
        class: 'w-50 m-auto',
      },
      // 預設縮圖
      defaultThumbnail: '',
      // 是否顯示底部文案
      showBottomHint: false,
      // 資料是否完成載入
      loadingCompleted: false,
    };
  },
  created() {
    const vm = this;

    // 取得頁面設定
    const getMemberCenterPageSetting = vm.$store.dispatch('getPageSetting', 'MemberCentreHomePage')
      .then((setting) => {
        // 預設縮圖
        vm.defaultThumbnail = pageSettingGetter.getFunction(setting, 'TitlePic').picUrl;
      });
    const getNotificationPageSetting = vm.$store.dispatch('getPageSetting', 'Notification')
      .then((setting) => {
        // 空白頁設定
        vm.emptyHint = {
          desc: pageSettingGetter.getFunctionWording(setting, 'BlankPageWording'),
          img: pageSettingGetter.getFunction(setting, 'BlankPagePic').picUrl,
        };
        // 樣式設定
        vm.spinnerStyle = setting.layoutType === '0' ? 'light' : 'secondary';
      });

    Promise.all([getMemberCenterPageSetting, getNotificationPageSetting])
      .then(() => {
        vm.loadingCompleted = true;
      });
  },
  methods: {
    // 取得資料 observable
    fetch(pagination, filters) {
      const headers = { accessToken: this.accessToken };
      const params = {
        dayFilter: filters.dayFilter,
        limit: pagination.limit,
        offset: pagination.offset,
      };
      return forkJoin({
        list: mbcService.getMemberNotice(params, headers).pipe(
          map((res) => {
            if (res.response && res.response.data) { return res.response.data; }
            return [];
          }),
        ),
      });
    },
    // 更新已讀時間
    patchReadTime(data) {
      const vm = this;
      // 若有未讀訊息，記錄已讀時間
      if (data.filter((x) => !x.readTime).length > 0) {
        const headers = { accessToken: vm.accessToken };
        vm.$subscribeTo(mbcService.patchMemberNoticeReadTime({}, headers));
      }
    },
  },
};
</script>
